declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../../animations/router.animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, TreatmentCyclesController, TreatmentCyclesRequest, IvfWorkbenchController, IvfWorkbenchRequest, CounsellingActivitiesByTimeController, CounsellingActivitiesByTimeRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, DeleteCycleActivityRequest, GenericProcPostRequest, S_Methods, SaveCounsellingActivityRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbEventAddModal } from '../TreatmentCycle/eventadd.modal';
import { ActivitesPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { Pipe } from '@angular/core';
import { Injectable } from '@angular/core';
import { PipeTransform } from '@angular/core';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { NgbEditCycleActivitiesModal } from '../TreatmentCycle/editcycleactivities.modal';
import { NgbEditActivityMonitoring2Modal } from '../../follow up/activitytracking/activitymonitoringmodal/editactivitymonitoring2.modal';
//import { NgbAddNewPatient } from './modal/addnewpatient.modal';

@Pipe({
    name: 'Activity2pipe'
})

@Injectable()
export class Activity2Pipe implements PipeTransform {

    transform(value: CounsellingActivitiesByTimeController[], filter: string): CounsellingActivitiesByTimeController[] {
        filter = filter ? filter.toLocaleLowerCase() : null;
        return filter ? value.filter((app: CounsellingActivitiesByTimeController) =>
            app.ActivityName != null && app.ActivityName.toLocaleLowerCase().indexOf(filter) != -1 ||
            app.ActivityTypeName != null && app.ActivityTypeName.toLocaleLowerCase().indexOf(filter) != -1 ||
            app.Remarks != null && app.Remarks.toLocaleLowerCase().indexOf(filter) != -1
        ) : value;
    }

}



@Component({
    selector: 'cycleactivities',
    templateUrl: './cycleactivities.component.html',
    styleUrls: [
        './cycleactivities.component.scss']
    , animations: [routerTransition()]
})

export class CycleActivitiesComponent implements OnInit {
    ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
        if (this.CanLoadReport) {
            // alert('loading xy report..');
            this.LoadPlan(this.CycleCode);

        }
       
        // alert(this.CanLoadReport);
        //// alert("called... xy change");
        // //  alert(this.ReportCategory);
        //// alert(changes[0].currentValue);
        //   var isChanged: SimpleChange = (changes["CanLoadReport"]);//as SimpleChange);

        // if ((isChanged != null)) {//&& isChanged.currentValue) {
        //     // alert(isChanged.
        //   //  this.CanLoadReport = true;
        //     if (this.CanLoadReport) {
        //      // alert('loading xy report..');
        //       this.LoadReportsByCategory();

        //     }
        //   }
        //   else {
        //     alert("load report false..");
        //    // this.CanLoadReport = false;
        //   }
        //   alert("XY CHART: " + this.FromDate);

    }


    GetActorIdentitiesController(): any {
        throw new Error("Method not implemented.");
    }
    @Input() ActivityName: string;
    @Input() CanLoadReport: boolean;
    @Input() ActorCode: number;
    @Input() CycleCode: number;
    @Input() LMPDate: Date;
    //public ActorCode: number = 0;
    public FormattedCode: number = 0;
    public isNew: boolean = false;
    public isEdit: boolean = false;
    public IsExpand: boolean = true;
    public Showarrow: boolean = false;
    public Showrow: boolean = true;
    public ShowPatientDetails: boolean = false;
    public Showivfbench: boolean = true;
    public ScanDetails: boolean = false;
    public PickUpDetails: boolean = false;
    public ETDetails: boolean = false;
    public SADetails: boolean = false;
    public InseminationDetails: boolean = false;
    public OQADetails: boolean = false;
    public GradingDetails: boolean = false;
    public FreezingDetails: boolean = false;
    searchTitle: string;
    public isRequesting: boolean = false;
    CurrentIsSessionExistsRequest: IsSessionExistsRequest;
    public ApiResData: ApiResponseModel;

    CurrentIvfworkbenchController: IvfWorkbenchController;
    CurrentIvfworkbenchRequest: IvfWorkbenchRequest;
    LoadIvf() {
        this.CurrentIvfworkbenchRequest = new IvfWorkbenchRequest;
        this.CurrentIvfworkbenchRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfWorkbenchController();
    }
    GetIvfWorkbenchController() {
        this.StartRefreshing();

        this.CurrentIvfworkbenchRequest.FromDate = new Date();
        this.CurrentIvfworkbenchRequest.ToDate = new Date();
        this.CurrentIvfworkbenchRequest.SearchText = "";
        this.CurrentIvfworkbenchRequest.Branch = "0";

        //this.CurrentFDActorDocRequest.ActorReportCode = null;
        //this.CurrentFDActorDocRequest.ActorReportTemplateCode = null;

        //alert(this.FormattedCode);
        this.actorservice.GetIvfWorkbenchController(this.CurrentIvfworkbenchRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfworkbenchController = this.ApiResData.Result;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
                    this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.LoadPatients();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentIvfTreatmentPlanController: IvfTreatmentPlanController[];
    PlanDetails: IvfTreatmentPlanController;
    CurrentIvfTreatmentPlanRequest: IvfTreatmentPlanRequest;
    LoadPlan(CycleCode:number) {
        this.CurrentIvfTreatmentPlanRequest = new IvfTreatmentPlanRequest();
        this.CurrentIvfTreatmentPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentIvfTreatmentPlanRequest.CycleCode = CycleCode;
        this.CurrentIvfTreatmentPlanRequest.ConditionalOperator = 10;
        this.CurrentIvfTreatmentPlanRequest.ActorCode = 0;


        this.GetIvfTreatmentPlanController();
    }
    GetIvfTreatmentPlanController() {
        this.StartRefreshing();
        //this.spinner.show();

        this.actorservice.GetIvfTreatmentPlanController(this.CurrentIvfTreatmentPlanRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    this.CurrentIvfTreatmentPlanController = this.ApiResData.Result;
                    this.PlanDetails = this.CurrentIvfTreatmentPlanController[0];
                    //this.CurrentCounsellingActivitiesByTimeController = this.ApiResData.Result;
                    //this.RefreshPatientsByDate();
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.spinner.hide();
                    this.stopRefreshing();
                    this.LoadActivities();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentCounsellingActivitiesByTimeController: CounsellingActivitiesByTimeController[];
  CurrentCounsellingActivitiesByTimeRequest: CounsellingActivitiesByTimeRequest;
  CurrentEditCounsellingActivityRequest: SaveCounsellingActivityRequest;
    LoadActivities() {
        this.CurrentCounsellingActivitiesByTimeRequest = new CounsellingActivitiesByTimeRequest();
        this.CurrentCounsellingActivitiesByTimeRequest.PlanCode = this.PlanDetails.FollowupPlanCode;
        //this.CurrentCounsellingActivitiesByTimeRequest.Branch = 0;
        this.CurrentCounsellingActivitiesByTimeRequest.ActorCode = this.PlanDetails.PatientActorCode;
        this.CurrentCounsellingActivitiesByTimeRequest.ConditionalOperator = 10;
        this.CurrentCounsellingActivitiesByTimeRequest.FromDate = new Date();
        this.CurrentCounsellingActivitiesByTimeRequest.ToDate = new Date();
        //this.CurrentCounsellingActivitiesByTimeRequest.IsToday = true;
        //this.CurrentCounsellingActivitiesByTimeRequest.IsDuration = false;
        this.CurrentCounsellingActivitiesByTimeRequest.BranchCode = AppData.Instance().SelectedBranchCode;
        this.CurrentCounsellingActivitiesByTimeRequest.SearchText = "";
        this.CurrentCounsellingActivitiesByTimeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.pdata = this.CurrentCounsellingActivitiesByTimeController;
        this.GetCounsellingActivitiesByTimeController();
    }
    GetCounsellingActivitiesByTimeController() {
        this.StartRefreshing();
        //this.spinner.show();

        this.actorservice.GetCounsellingActivitiesByTimeController(this.CurrentCounsellingActivitiesByTimeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentCounsellingActivitiesByTimeController = this.ApiResData.Result;
                    this.pdata = this.CurrentCounsellingActivitiesByTimeController;
                    //this.RefreshPatientsByDate();
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.spinner.hide();
                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    sub: Subscription;
    constructor(private router: Router,
        private loaderService: SpinnerService,
        private hcpservice: HCPService,
        private actorservice: ActorService,
        private modalService: NgbModal,
        private route: ActivatedRoute,
        private filter: Activity2Pipe,
        private tosterservice: NGXToastrService,
        private loginservice: LoginService) { }

    ngOnInit() {
        //alert(this.ActivityName);

        //this.GetPatientInfoByFormattedCodeController();
        //alert(this.CanLoadReport);
        this.LoadPlan(this.CycleCode);
      this.LoadPatients();
      this.CurrentEditCounsellingActivityRequest = new SaveCounsellingActivityRequest;
      this.CurrentEditCounsellingActivityRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    }



    ShowList: boolean = true;


    //criteriaChange(value: any) {

    //}
    BackToProfile() {
        this.ShowList = true;
        this.ShowPatientDetails = false;
        this.Showarrow = false;
  }
  EditCycleActivity(l: CounsellingActivitiesByTimeController) {

    this.CurrentEditCounsellingActivityRequest.ActivityDate = l.ActivityDate;
    this.CurrentEditCounsellingActivityRequest.ActivityTime = l.ActivityTime;
    this.CurrentEditCounsellingActivityRequest.FollowupMode = l.FollowupMode;
    this.CurrentEditCounsellingActivityRequest.Followupstatus = l.FollowupStatus;
    this.CurrentEditCounsellingActivityRequest.ActualActivityDate = l.ActualActivityDate;
    this.CurrentEditCounsellingActivityRequest.ActualActivityTime = l.ActualActivityTime;
    this.CurrentEditCounsellingActivityRequest.Remarks = l.Remarks;
    this.CurrentEditCounsellingActivityRequest.PlanCode = l.PlanCode;
    this.CurrentEditCounsellingActivityRequest.ActorCode = l.ActorCode;
    this.CurrentEditCounsellingActivityRequest.CounsellingActivityCode = l.CounsellingActivityCode;
    this.CurrentEditCounsellingActivityRequest.CreatedUser = l.CreatedUser;
    this.CurrentEditCounsellingActivityRequest.AssignedToName = l.AssignedToName;
    const modalRef = this.modalService.open(NgbEditActivityMonitoring2Modal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.CurrentEditCounsellingActivityRequest = this.CurrentEditCounsellingActivityRequest;
    modalRef.componentInstance.ADate = l.ActivityDate;
    modalRef.componentInstance.Time = l.ActivityTime;
    modalRef.componentInstance.AtrCode = l.ActorCode;
    modalRef.componentInstance.Code = l.PlanCode;
    modalRef.componentInstance.Name = l.DisplayName;
    modalRef.componentInstance.CreatedUserName = l.CreatedUser;
    modalRef.componentInstance.AssignedToName = l.AssignedToName;
    modalRef.result.then(x => { this.GetCounsellingActivitiesByTimeController() })
  }
  //EditCycleActivity(l) {
  //  const modalRef = this.modalService.open(NgbEditCycleActivitiesModal,
  //    {
  //      centered: true,
  //      size: "lg",
  //      keyboard: false

  //    })
  //  modalRef.componentInstance.ActivityTypeName = l.ActivityTypeName;
  //  modalRef.componentInstance.CounsellingActivityCode = l.CounsellingActivityCode;
  //  modalRef.componentInstance.ActivityName = l.ActivityName;
  //  modalRef.componentInstance.Remarks = l.Remarks;
  //  modalRef.componentInstance.DisplayName = l.DisplayName;
  //  modalRef.componentInstance.FormattedCode = l.FormattedCode;
  //  modalRef.componentInstance.PlanName = l.PlanName;
  //  modalRef.componentInstance.ActivityDate = l.ActivityDate;
  //  modalRef.result.then(x => { this.LoadActivities() })
  //}
  DeleteCycleActivity(l) {
    swal({
      title: 'Are you sure?',
      text: "You want to delete!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.DeleteActivity(l);

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })

  }
  DeleteActivity(l) {
    var saveReq = new DeleteCycleActivityRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 80150;
    saveReq.ActorCode = l.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.CounsellingActivityCode = l.CounsellingActivityCode;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 80150;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.LoadActivities();
            //this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
    clearData() {
        this.isNew = true;
        this.ShowList = false;

    }
    ExpandData() {
        if (this.IsExpand === true) {
            this.IsExpand = false;
        }
        else {
            this.IsExpand = true;
        }
    }
    display(l: IvfWorkbenchController) {
        if (l.Name == "Scans") {
            this.router.navigate(['healins/ivfscans']);
        }
        else if (l.Name == "Ready for Pickup" || l.Name == "PickUps") {
            this.router.navigate(['healins/ivfpickups']);
        }
        else if (l.Name == "Oocyte Quality Assessment") {
            this.router.navigate(['healins/ivfoqa']);
        }
        else if (l.Name == "Insemination") {
            this.router.navigate(['healins/ivfinsemination']);
        }
        else if (l.Name == "EmbryoGrading") {
            this.router.navigate(['healins/ivfembryograding']);
        }
        else if (l.Name == "ReadyForTransfer") {
            this.router.navigate(['healins/ivffreezing']);
        }
        else if (l.Name == "FET Grading") {

        }
        else if (l.Name == "Calander") {

        }
        else if (l.Name == "") {

        }
    }
    displayscans() {
        //this.Showivfbench = false;
        //this.ScanDetails = true;
        this.router.navigate(['healins/ivfscans']);
    }
    displaypickup() {
        //this.Showivfbench = false;
        //this.PickUpDetails = true;
        this.router.navigate(['healins/ivfpickups']);
    }
    displayet() {
        //this.Showivfbench = false;
        //this.ETDetails = true;
        this.router.navigate(['healins/ivfembryotransfer']);
    }
    displaysa() {
        //this.Showivfbench = false;
        //this.SADetails = true;
        this.router.navigate(['healins/ivfsemen']);
    }
    displayinsemination() {
        //this.Showivfbench = false;
        //this.InseminationDetails = true;
        this.router.navigate(['healins/ivfinsemination']);
    }
    displayoqa() {
        //this.Showivfbench = false;
        //this.OQADetails = true;
        this.router.navigate(['healins/ivfoqa']);
    }
    displaygrading() {
        //this.Showivfbench = false;
        //this.GradingDetails = true;
        this.router.navigate(['healins/ivfembryograding']);
    }
    displayfreezing() {
        //this.Showivfbench = false;
        //this.FreezingDetails = true;
        this.router.navigate(['healins/ivffreezing']);
    }
    //AddNewPatient() {

    //  const modalRef = this.modalService.open(NgbAddNewPatient,
    //    {
    //      centered: true,
    //      size: "lg",
    //      backdrop: 'static',
    //      keyboard: false
    //    })
    //  modalRef.componentInstance.ActorCode = this.ActorCode;
    //  //modalRef.componentInstance.ActorCode = this.ActorCode;
    //  modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })

    //}
    CancelNewOperation() {

        this.ShowList = true;
    }

    ///////////
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }


    gotoprofile() {
        this.router.navigate(['testnurse/profile']);

    }
    pdata: any[];// = this.data;
    listFilter: string;
    //ngOnChanges(changes: any) {
    //    if (JSON.stringify(changes).indexOf("data") != -1)
    //        this.pdata = this.CurrentCounsellingActivitiesByTimeController;

    //    this.criteriaChange(this.listFilter);

    //}
    criteriaChange(value: any) {
        if (this.filter != null) {
            if (value != '[object Event]') {
                this.listFilter = value;
                //alert(this.listFilter);
                this.pdata = this.filter.transform(this.CurrentCounsellingActivitiesByTimeController,
                    this.listFilter);
            }
        }
    }

    //SelectedPatient: PatientInfoByFormattedCodeController;
    //ViewPatientDetails(objCategory: any) {
    //  var patient: PatientInfoByFormattedCodeController = objCategory;

    //  if (patient != null) {



    //    this.ShowPatientDetails = true;
    //    this.ShowList = false;
    //    this.SelectedPatient = patient;
    //    this.Showarrow = true;
    //    this.Showrow = false;
    //    //this.LoadPatientdetails()

    //  }
    //  else {
    //    this.ShowPatientDetails = false;
    //  }
    //}
    //SelectedPatientDetailsController: PatientInfoByFormattedCodeController;
    //SelectedPatientDetailsRequest: PatientInfoByFormattedCodeRequest;
    //LoadPatientdetails() {


    //  this.SelectedPatientDetailsRequest = new PatientInfoByFormattedCodeRequest();

    //  this.SelectedPatientDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //  this.SelectedPatientDetailsRequest.FormattedCode = this.SelectedPatient.ActorCode.toString();// AppData.Instance().UserLoginDetails.FacilityActorCode;
    //  this.GetPatientInfoByFormattedCodeController();
    //}
    SelectedPatient: TreatmentCyclesController;
    ViewPatientDetails(objCategory: any) {
        var patient: TreatmentCyclesController = objCategory;
        if (patient != null) {
            this.SelectedPatient = null;
            this.SelectedPatient = patient;
            this.ShowList = false;
            this.ShowPatientDetails = true;
            this.Showarrow = false;
            this.Showrow = false;
            //this.ShowData = false;

        }
        else {

        }

    }
    CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
    ActorDetails: TreatmentCyclesByActorCodeController;
    CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
    LoadPatients() {
        //alert("cycle");
        this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCode;
        this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController();
    }

    GetTreatmentCyclesByActorCodeController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
                    this.ActorDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
                    
                    //this.LMPDate = this.CurrentTreatmentCyclesByActorCodeController[0].LMP;
                    //var LMPDate = this.CurrentTreatmentCyclesByActorCodeController[0].LMP;
                    //this.LMPDay = LMPDate[8] + LMPDate[9];
                    //alert(this.LMPDay);
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.LoadDSAData();
                    this.stopRefreshing();
                    //this.LoadPlan();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
    // DSADetails: DSAActivityByCycleCodeController;
    //DSADetails: DSAActivityByCycleCodeController;
    CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;
    DSADetails: DSAActivityByCycleCodeController;
    LoadDSAData() {
        // alert("ScansData");
        this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.GetActorCode2(this.ActorDetails.EggSourceType, this.ActorDetails.RecepientType);
        this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
        this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetDSAActivityByCycleCodeController();
    }

    GetDSAActivityByCycleCodeController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;


        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
                    this.DSADetails = this.GetCycleActivity2(this.GetActorCode2(this.ActorDetails.EggSourceType, this.ActorDetails.RecepientType), this.ActorDetails.ProtocolStartDate)[0];
                    // this.DSADetails = this.GetCycleActivity(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.FollicularScanEndInfo.ScanDate)[0];
                    //alert(this.DSADetails);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

                    //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
                    //var list = this.CurrentDSAActivityByCycleCodeController.filter(


                    //    function (a) {
                    //        var Date = this.FollicularScanEndInfo.ScanDate;
                    //        var ActorCode = this.SelectedpatientDetails.ActorID;
                    //        return a.ActivityDate == Date && a.ActorCode == ActorCode
                    //    });

                    //this.CurrentDSAActivityByCycleCodeController = list;
                    //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
                    //alert(this.Doc1);
                    //alert(this.Antag);
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    GetActorCode2(EggSourceType: string, ReceipentType: string) {
        //alert(EggSourceType);
        //alert(ReceipentType);
        if (EggSourceType == 'Self' && ReceipentType == 'Self') {
            var ActorCode = this.ActorDetails.EggActorCode;
            return ActorCode;
        }
        else if (EggSourceType == 'Donor' && ReceipentType == 'Self') {
            var ActorCode = this.ActorDetails.EggActorCode;
            return ActorCode;
        }
        else if (EggSourceType == 'Self' && ReceipentType == 'Donor') {
            var ActorCode = this.ActorDetails.RecepientActorCode;
            return ActorCode;
        }
        else if (EggSourceType == 'Donor' && ReceipentType == 'Donor') {
            var ActorCode = this.ActorDetails.EggActorCode;
            return ActorCode;
        }

    }
    GetCycleActivity2(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
        //alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentDSAActivityByCycleCodeController.filter(
            function (v, i, d) {

                return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
            }
        )

    }
    AddEventDetails() {
        const modalRef = this.modalService.open(NgbEventAddModal,
            {
                centered: true,
                size: "lg"

            })
        modalRef.componentInstance.ActorCodeNew = this.ActorCode;
        modalRef.componentInstance.CycleCode = this.CycleCode;
        modalRef.componentInstance.Plancode = this.PlanDetails.FollowupPlanCode;
        modalRef.componentInstance.LMPDate = this.LMPDate;
        modalRef.componentInstance.ActivityName = this.ActivityName;
        modalRef.componentInstance.Doc1 = this.DSADetails.DOC;
        modalRef.componentInstance.Antag = this.DSADetails.ANTAG;
      modalRef.componentInstance.Stimulation = this.DSADetails.STIMULATION;
        modalRef.componentInstance.TCModelName = this.ActorDetails.TCModelName;
        modalRef.componentInstance.ModalName = "oldmodal";
        //modalRef.componentInstance.OwnerName = this.TreamentCycleDetails.OwnerName;
        //modalRef.componentInstance.OwnerFormattedCode = this.TreamentCycleDetails.OwnerFormattedCode;
        //modalRef.componentInstance.OwnerPatientImageFile = this.TreamentCycleDetails.OwnerPatientImageFile;
        //modalRef.componentInstance.Protocol = l.Protocol;
        //modalRef.componentInstance.OwnerGender = l.OwnerGender
        //modalRef.componentInstance.OwnerAgeYears = l.OwnerAgeYears;
        modalRef.result.then(x => { this.GetCounsellingActivitiesByTimeController() })
    }


  
}
